export default "__VITE_ASSET__DQTmZ6Zs__"